module.exports = __webpack_public_path__ + "img/motiplate-logo-colour.182dae2d.png";